const Error404 = () => {
    return (  
        <p className="error404">La página que buscas no existe...</p>
    );
}
 
export default Error404;